import React from "react";

export default function Support() {
  return (
    <div>
      <h1>Support Page</h1>
    </div>
  );
}
